export default __webpack_public_path__ + "static/media/produto-nutricional-bananinha.2584693c.png";